import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import AnimatedBackground from "./components/AnimatedBackground";
import CustomCursor from "./components/CustomCursor";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollToTopButton from "./components/ScrollToTopButton";
function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <>
      <AnimatedBackground>
        <CustomCursor />
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
        </Routes>
      </AnimatedBackground>
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

export default App;
